
import { useState } from 'react';
import Button from '../base/Button';

export default function SearchSection() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showStateDropdown, setShowStateDropdown] = useState(false);

  const categories = [
    'Todas las categorías',
    'Fútbol 11',
    'Fútbol 7',
    'Fútbol 5',
    'Futsal',
    'Fútbol Playa'
  ];

  const states = [
    'Todos los estados',
    'Ciudad de México',
    'Guadalajara',
    'Monterrey',
    'Puebla',
    'Tijuana',
    'León',
    'Juárez',
    'Torreón'
  ];

  const handleSearch = () => {
    console.log('Búsqueda:', { searchTerm, selectedCategory, selectedState });
  };

  return (
    <section className="bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8">
            Encuentra tu Cancha Ideal
          </h2>
          
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              {/* Search Input */}
              <div className="md:col-span-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="Buscar por nombre o ubicación..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full px-4 py-3 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm"
                  />
                  <i className="ri-search-line absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
                </div>
              </div>

              {/* Category Dropdown */}
              <div className="relative">
                <button
                  onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
                  className="w-full px-4 py-3 text-left border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white cursor-pointer text-sm flex items-center justify-between"
                >
                  <span className={selectedCategory || 'text-gray-500'}>
                    {selectedCategory || 'Categoría'}
                  </span>
                  <i className={`ri-arrow-down-s-line transition-transform ${showCategoryDropdown ? 'rotate-180' : ''}`}></i>
                </button>
                
                {showCategoryDropdown && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10">
                    {categories.map((category) => (
                      <button
                        key={category}
                        onClick={() => {
                          setSelectedCategory(category);
                          setShowCategoryDropdown(false);
                        }}
                        className="w-full px-4 py-2 text-left hover:bg-gray-50 text-sm cursor-pointer"
                      >
                        {category}
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* State Dropdown */}
              <div className="relative">
                <button
                  onClick={() => setShowStateDropdown(!showStateDropdown)}
                  className="w-full px-4 py-3 text-left border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent bg-white cursor-pointer text-sm flex items-center justify-between"
                >
                  <span className={selectedState || 'text-gray-500'}>
                    {selectedState || 'Estado'}
                  </span>
                  <i className={`ri-arrow-down-s-line transition-transform ${showStateDropdown ? 'rotate-180' : ''}`}></i>
                </button>
                
                {showStateDropdown && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-10">
                    {states.map((state) => (
                      <button
                        key={state}
                        onClick={() => {
                          setSelectedState(state);
                          setShowStateDropdown(false);
                        }}
                        className="w-full px-4 py-2 text-left hover:bg-gray-50 text-sm cursor-pointer"
                      >
                        {state}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
            
            <div className="mt-6 text-center">
              <Button onClick={handleSearch} size="lg" className="px-8">
                <i className="ri-search-line mr-2"></i>
                Buscar Canchas
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
